import { GET_NOTIFICATION_LIST, GET_NOTIFICATION_LIST_SUCCESS, NOTIFICATION_SWITCH, NOTIFICATION_SWITCH_CHANGE, NOTIFICATION_MARK_AS_READ, NOTIFICATION_MARK_AS_READ_SUCCESS } from '../constants/actionTypes';

export const getNotificationList = payload => ({
    type: GET_NOTIFICATION_LIST,
    payload
});

export const getNotificationListSuccess = payload => ({
    type: GET_NOTIFICATION_LIST_SUCCESS,
    payload
});

export const notificationSwitch = payload => ({
    type: NOTIFICATION_SWITCH,
    payload
})

export const notificationSwitchChange = payload => ({
    type: NOTIFICATION_SWITCH_CHANGE,
    payload
})

export const notificationMarkAsRead = payload => ({
    type: NOTIFICATION_MARK_AS_READ,
    payload
});

export const notificationMarkAsReadSuccess = payload => ({
    type: NOTIFICATION_MARK_AS_READ_SUCCESS,
    payload
});